import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/.pruned/json/apps/web-app/src/components/layout/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/.pruned/json/node_modules/next-translate/lib/esm/AppDirI18nProvider.js");
